module.exports = __webpack_public_path__ + "static/img/new-021.825bdfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-021.png
// module id = rSCB
// module chunks = 1